import {HashRouter, Route, Routes, useLocation} from 'react-router-dom';
import './App.css';
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Nav from "./components/Nav";
import About from "./pages/About";
import SolutionsPage from "./pages/Solutions";
import Products from "./pages/Products";
import Documents from "./pages/Documents";
import Solution from "./pages/Solution";
import Service from "./pages/Service";
import Product from "./pages/Product";
import {useLanguageStore} from "./store/languageStore";
import {useEffect} from "react";

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}


function App() {

    const {language} = useLanguageStore()
    const isArabic = language === 'ar'



  return (
      <div className={` mx-auto ${isArabic ? 'font-arabic' : ''} `}>
          <HashRouter basename="/">
              <Nav/>
              <ScrollToTop />
              <Routes>
                  <Route path="/" active element={<Home/>}/>
                  <Route path="/about" element={<About/>}/>
                  <Route path="/solutions" element={<SolutionsPage/>}/>
                  <Route path="/solution/:id" element={<Solution/>}/>
                  <Route path="/services/:id" element={<Service/>}/>
                  <Route path="/products" element={<Products/>}/>
                  <Route path="/product/:id" element={<Product/>}/>
                  <Route path="/Documents" element={<Documents/>}/>


              </Routes>
              <Footer/>
          </HashRouter>

      </div>
  );
}

export default App;
